<template>
  <div class="card-bd">
    <div v-show="currentView === 'login'">
      <div class="tab-bar">
        <div
          class="tab-pill"
          :style="{
            transform:
              loginMode === 'account' ? 'translateX(0)' : 'translateX(100%)',
          }"
        ></div>
        <button
          @click="$emit('set-login-mode', 'account')"
          :class="['tab-btn', loginMode === 'account' && 'tab-btn--active']"
        >
          账号登录
        </button>
        <button
          @click="$emit('set-login-mode', 'phone')"
          :class="['tab-btn', loginMode === 'phone' && 'tab-btn--active']"
        >
          手机登录
        </button>
      </div>

      <div v-show="loginMode === 'account'" class="form-space">
        <div class="ig">
          <div :class="['iw', errors.accUsername && 'iw--err']">
            <span :class="['ii', errors.accUsername && 'ii--err']"
              ><i data-lucide="user"></i
            ></span>
            <input
              :value="form.accUsername"
              @input="handleFieldInput('accUsername', $event.target.value)"
              @keydown.enter="$emit('submit')"
              type="text"
              name="username"
              autocomplete="username"
              placeholder="请输入账号"
              :class="['fi', errors.accUsername && 'fi--err']"
            />
            <svg
              v-show="form.accUsername.length > 0"
              @click="clearField('accUsername')"
              class="ic-clear"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
          </div>
          <div v-show="errors.accUsername" class="err-tip">
            <i data-lucide="alert-circle" class="err-ic"></i
            ><span>账号不能为空</span>
          </div>
        </div>
        <div class="ig">
          <div :class="['iw', errors.accPwd && 'iw--err']">
            <span :class="['ii', errors.accPwd && 'ii--err']"
              ><i data-lucide="lock"></i
            ></span>
            <input
              :value="form.accPwd"
              @input="handleFieldInput('accPwd', $event.target.value)"
              @keydown.enter="$emit('submit')"
              :type="pwdVis.acc ? 'text' : 'password'"
              name="password"
              autocomplete="current-password"
              placeholder="请输入密码"
              :class="['fi fi--pr', errors.accPwd && 'fi--err']"
            />
            <div class="ia">
              <svg
                v-show="form.accPwd.length > 0"
                @click="clearField('accPwd')"
                class="ic-clear"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                />
              </svg>
              <span @click="togglePwd('acc')" class="ic-eye">
                <span v-show="pwdVis.acc" class="ic-eye-inner"
                  ><i data-lucide="eye"></i
                ></span>
                <span v-show="!pwdVis.acc" class="ic-eye-inner"
                  ><i data-lucide="eye-off"></i
                ></span>
              </span>
            </div>
          </div>
          <div v-show="errors.accPwd" class="err-tip">
            <i data-lucide="alert-circle" class="err-ic"></i
            ><span>密码不能为空</span>
          </div>
        </div>
        <div class="form-foot">
          <div class="form-foot-l">
            还没有账户？<button
              @click="$emit('switch-view', 'register')"
              class="lnk-btn"
            >
              注册
            </button>
          </div>
          <button @click="$emit('switch-view', 'forgot')" class="lnk-btn-sec">
            忘记密码
          </button>
        </div>
      </div>

      <div v-show="loginMode === 'phone'" class="form-space">
        <div class="ig">
          <div :class="['iw', errors.phMobile && 'iw--err']">
            <span :class="['ii', errors.phMobile && 'ii--err']"
              ><i data-lucide="smartphone"></i
            ></span>
            <input
              :value="form.phMobile"
              @input="handleFieldInput('phMobile', $event.target.value)"
              type="tel"
              placeholder="请输入手机号"
              :class="['fi', errors.phMobile && 'fi--err']"
            />
            <svg
              v-show="form.phMobile.length > 0"
              @click="clearField('phMobile')"
              class="ic-clear"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
          </div>
          <div v-show="errors.phMobile" class="err-tip">
            <i data-lucide="alert-circle" class="err-ic"></i
            ><span>请输入正确的手机号</span>
          </div>
        </div>
        <div class="ig">
          <div class="code-row">
            <div :class="['iw flex1', errors.phCode && 'iw--err']">
              <span :class="['ii', errors.phCode && 'ii--err']"
                ><i data-lucide="mail"></i
              ></span>
              <input
                :value="form.phCode"
                @input="handleFieldInput('phCode', $event.target.value)"
                @keydown.enter="$emit('submit')"
                type="text"
                placeholder="短信验证码"
                :class="['fi', errors.phCode && 'fi--err']"
              />
              <svg
                v-show="form.phCode.length > 0"
                @click="clearField('phCode')"
                class="ic-clear"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
                />
              </svg>
            </div>
            <button
              @click="$emit('send-sms-code', 'ph')"
              :disabled="!isPhoneValid(form.phMobile) || countdown.ph.active"
              :class="[
                'sms-btn',
                (!isPhoneValid(form.phMobile) || countdown.ph.active) &&
                  'sms-btn--off',
              ]"
            >
              {{
                countdown.ph.active
                  ? `${countdown.ph.time}s后重取`
                  : "获取验证码"
              }}
            </button>
          </div>
          <div v-show="errors.phCode" class="err-tip">
            <i data-lucide="alert-circle" class="err-ic"></i
            ><span>请输入验证码</span>
          </div>
        </div>
        <div class="form-foot">
          <div class="form-foot-l">
            还没有账户？<button
              @click="$emit('switch-view', 'register')"
              class="lnk-btn"
            >
              注册
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-show="currentView === 'register'" class="form-space">
      <div class="view-hd">
        <button @click="$emit('switch-view', 'login')" class="back-btn">
          <i data-lucide="arrow-left" class="back-ic"></i>返回登录
        </button>
        <h2 class="view-title">创建新账户</h2>
      </div>
      <div class="ig">
        <div :class="['iw', errors.regUsername && 'iw--err']">
          <span :class="['ii', errors.regUsername && 'ii--err']"
            ><i data-lucide="user-plus"></i
          ></span>
          <input
            :value="form.regUsername"
            @input="handleFieldInput('regUsername', $event.target.value)"
            type="text"
            placeholder="请输入账号"
            :class="['fi', errors.regUsername && 'fi--err']"
          />
          <svg
            v-show="form.regUsername.length > 0"
            @click="clearField('regUsername')"
            class="ic-clear"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
            />
          </svg>
        </div>
        <div v-show="errors.regUsername" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>请输入要注册的账号</span>
        </div>
      </div>
      <div class="ig">
        <div :class="['iw', errors.regMobile && 'iw--err']">
          <span :class="['ii', errors.regMobile && 'ii--err']"
            ><i data-lucide="smartphone"></i
          ></span>
          <input
            :value="form.regMobile"
            @input="handleFieldInput('regMobile', $event.target.value)"
            type="tel"
            placeholder="绑定手机号"
            :class="['fi', errors.regMobile && 'fi--err']"
          />
          <svg
            v-show="form.regMobile.length > 0"
            @click="clearField('regMobile')"
            class="ic-clear"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
            />
          </svg>
        </div>
        <div v-show="errors.regMobile" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>手机号格式错误</span>
        </div>
      </div>
      <div class="ig">
        <div class="code-row">
          <div :class="['iw flex1', errors.regCode && 'iw--err']">
            <span :class="['ii', errors.regCode && 'ii--err']"
              ><i data-lucide="mail"></i
            ></span>
            <input
              :value="form.regCode"
              @input="handleFieldInput('regCode', $event.target.value)"
              type="text"
              placeholder="短信验证码"
              :class="['fi', errors.regCode && 'fi--err']"
            />
            <svg
              v-show="form.regCode.length > 0"
              @click="clearField('regCode')"
              class="ic-clear"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
          </div>
          <button
            @click="$emit('send-sms-code', 'reg')"
            :disabled="!isPhoneValid(form.regMobile) || countdown.reg.active"
            :class="[
              'sms-btn',
              (!isPhoneValid(form.regMobile) || countdown.reg.active) &&
                'sms-btn--off',
            ]"
          >
            {{
              countdown.reg.active
                ? `${countdown.reg.time}s后重取`
                : "获取验证码"
            }}
          </button>
        </div>
        <div v-show="errors.regCode" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>请输入验证码</span>
        </div>
      </div>
      <div class="ig">
        <div :class="['iw', errors.regPwd && 'iw--err']">
          <span :class="['ii', errors.regPwd && 'ii--err']"
            ><i data-lucide="lock"></i
          ></span>
          <input
            :value="form.regPwd"
            @input="handleFieldInput('regPwd', $event.target.value)"
            :type="pwdVis.reg1 ? 'text' : 'password'"
            placeholder="密码 (8-16位，含字母、数字和符号)"
            :class="['fi fi--pr', errors.regPwd && 'fi--err']"
          />
          <div class="ia">
            <svg
              v-show="form.regPwd.length > 0"
              @click="clearField('regPwd')"
              class="ic-clear"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
            <span @click="togglePwd('reg1')" class="ic-eye">
              <span v-show="pwdVis.reg1" class="ic-eye-inner"
                ><i data-lucide="eye"></i
              ></span>
              <span v-show="!pwdVis.reg1" class="ic-eye-inner"
                ><i data-lucide="eye-off"></i
              ></span>
            </span>
          </div>
        </div>
        <div v-show="errors.regPwd" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>密码需8-16位且包含字母、数字和符号</span>
        </div>
      </div>
      <div class="ig">
        <div :class="['iw', errors.regPwdConfirm && 'iw--err']">
          <span :class="['ii', errors.regPwdConfirm && 'ii--err']"
            ><i data-lucide="lock"></i
          ></span>
          <input
            :value="form.regPwdConfirm"
            @input="handleFieldInput('regPwdConfirm', $event.target.value)"
            :type="pwdVis.reg2 ? 'text' : 'password'"
            placeholder="再次确认密码"
            :class="['fi fi--pr', errors.regPwdConfirm && 'fi--err']"
          />
          <div class="ia">
            <svg
              v-show="form.regPwdConfirm.length > 0"
              @click="clearField('regPwdConfirm')"
              class="ic-clear"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
            <span @click="togglePwd('reg2')" class="ic-eye">
              <span v-show="pwdVis.reg2" class="ic-eye-inner"
                ><i data-lucide="eye"></i
              ></span>
              <span v-show="!pwdVis.reg2" class="ic-eye-inner"
                ><i data-lucide="eye-off"></i
              ></span>
            </span>
          </div>
        </div>
        <div v-show="errors.regPwdConfirm" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>两次密码不一致</span>
        </div>
      </div>
    </div>

    <div v-show="currentView === 'forgot'" class="form-space">
      <div class="view-hd">
        <button @click="$emit('switch-view', 'login')" class="back-btn">
          <i data-lucide="arrow-left" class="back-ic"></i>返回登录
        </button>
        <h2 class="view-title">找回密码</h2>
      </div>
      <div class="ig">
        <div :class="['iw', errors.fgtMobile && 'iw--err']">
          <span :class="['ii', errors.fgtMobile && 'ii--err']"
            ><i data-lucide="smartphone"></i
          ></span>
          <input
            :value="form.fgtMobile"
            @input="handleFieldInput('fgtMobile', $event.target.value)"
            type="tel"
            placeholder="注册手机号"
            :class="['fi', errors.fgtMobile && 'fi--err']"
          />
          <svg
            v-show="form.fgtMobile.length > 0"
            @click="clearField('fgtMobile')"
            class="ic-clear"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
            />
          </svg>
        </div>
        <div v-show="errors.fgtMobile" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>手机号格式错误</span>
        </div>
      </div>
      <div class="ig">
        <div class="code-row">
          <div :class="['iw flex1', errors.fgtCode && 'iw--err']">
            <span :class="['ii', errors.fgtCode && 'ii--err']"
              ><i data-lucide="mail"></i
            ></span>
            <input
              :value="form.fgtCode"
              @input="handleFieldInput('fgtCode', $event.target.value)"
              type="text"
              placeholder="短信验证码"
              :class="['fi', errors.fgtCode && 'fi--err']"
            />
            <svg
              v-show="form.fgtCode.length > 0"
              @click="clearField('fgtCode')"
              class="ic-clear"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
          </div>
          <button
            @click="$emit('send-sms-code', 'fgt')"
            :disabled="!isPhoneValid(form.fgtMobile) || countdown.fgt.active"
            :class="[
              'sms-btn',
              (!isPhoneValid(form.fgtMobile) || countdown.fgt.active) &&
                'sms-btn--off',
            ]"
          >
            {{
              countdown.fgt.active
                ? `${countdown.fgt.time}s后重取`
                : "获取验证码"
            }}
          </button>
        </div>
        <div v-show="errors.fgtCode" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>请输入验证码</span>
        </div>
      </div>
      <div class="ig">
        <div :class="['iw', errors.fgtPwd && 'iw--err']">
          <span :class="['ii', errors.fgtPwd && 'ii--err']"
            ><i data-lucide="lock"></i
          ></span>
          <input
            :value="form.fgtPwd"
            @input="handleFieldInput('fgtPwd', $event.target.value)"
            :type="pwdVis.fgt1 ? 'text' : 'password'"
            placeholder="新密码 (8-16位，含字母、数字和符号)"
            :class="['fi fi--pr', errors.fgtPwd && 'fi--err']"
          />
          <div class="ia">
            <svg
              v-show="form.fgtPwd.length > 0"
              @click="clearField('fgtPwd')"
              class="ic-clear"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
            <span @click="togglePwd('fgt1')" class="ic-eye">
              <span v-show="pwdVis.fgt1" class="ic-eye-inner"
                ><i data-lucide="eye"></i
              ></span>
              <span v-show="!pwdVis.fgt1" class="ic-eye-inner"
                ><i data-lucide="eye-off"></i
              ></span>
            </span>
          </div>
        </div>
        <div v-show="errors.fgtPwd" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>密码格式不合规</span>
        </div>
      </div>
      <div class="ig">
        <div :class="['iw', errors.fgtPwdConfirm && 'iw--err']">
          <span :class="['ii', errors.fgtPwdConfirm && 'ii--err']"
            ><i data-lucide="lock"></i
          ></span>
          <input
            :value="form.fgtPwdConfirm"
            @input="handleFieldInput('fgtPwdConfirm', $event.target.value)"
            :type="pwdVis.fgt2 ? 'text' : 'password'"
            placeholder="再次确认新密码"
            :class="['fi fi--pr', errors.fgtPwdConfirm && 'fi--err']"
          />
          <div class="ia">
            <svg
              v-show="form.fgtPwdConfirm.length > 0"
              @click="clearField('fgtPwdConfirm')"
              class="ic-clear"
              viewBox="0 0 24 24"
              fill="currentColor"
            >
              <path
                d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
              />
            </svg>
            <span @click="togglePwd('fgt2')" class="ic-eye">
              <span v-show="pwdVis.fgt2" class="ic-eye-inner"
                ><i data-lucide="eye"></i
              ></span>
              <span v-show="!pwdVis.fgt2" class="ic-eye-inner"
                ><i data-lucide="eye-off"></i
              ></span>
            </span>
          </div>
        </div>
        <div v-show="errors.fgtPwdConfirm" class="err-tip">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>两次密码不一致</span>
        </div>
      </div>
    </div>

    <div v-show="currentView === '2fa'" class="form-space">
      <div class="twofa-hd">
        <div class="twofa-icon-box">
          <i data-lucide="scan-face" class="twofa-main-ic"></i>
        </div>
        <h2 class="twofa-title">身份验证码</h2>
        <p class="twofa-desc">保护您的数据，请输入验证器上的 6 位动态密码</p>
      </div>
      <div class="ig">
        <div :class="['iw', errors.twofaCode && 'iw--err']">
          <span :class="['ii', errors.twofaCode && 'ii--err']"
            ><i data-lucide="shield-check"></i
          ></span>
          <input
            :key="twofaInputName"
            :value="form.twofaCode"
            @input="handleFieldInput('twofaCode', $event.target.value, $event)"
            @keydown.enter="$emit('submit')"
            type="text"
            :name="twofaInputName"
            :id="twofaInputName"
            inputmode="numeric"
            pattern="[0-9]*"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            maxlength="6"
            placeholder="000000"
            :class="['fi fi--twofa', errors.twofaCode && 'fi--err']"
          />
          <svg
            v-show="form.twofaCode.length > 0"
            @click="clearField('twofaCode')"
            class="ic-clear"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
            />
          </svg>
        </div>
        <div v-show="errors.twofaCode" class="err-tip err-tip--c">
          <i data-lucide="alert-circle" class="err-ic"></i
          ><span>验证码错误或已过期</span>
        </div>
      </div>
      <div class="twofa-foot">
        <button
          @click="$emit('switch-view', 'login')"
          class="back-btn twofa-back"
        >
          <i data-lucide="arrow-left" class="back-ic"></i>返回登录
        </button>
        <button class="help-btn" @click="$emit('open-help')">
          <i data-lucide="help-circle" class="help-ic"></i>如何使用?
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginAuthViews",
  data() {
    return {
      twofaInputName: this.createTwofaInputName(),
    };
  },
  props: {
    currentView: {
      type: String,
      required: true,
    },
    loginMode: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
    pwdVis: {
      type: Object,
      required: true,
    },
    countdown: {
      type: Object,
      required: true,
    },
    isPhoneValid: {
      type: Function,
      required: true,
    },
  },
  watch: {
    currentView(view) {
      if (view === "2fa") {
        this.twofaInputName = this.createTwofaInputName();
      }
    },
  },
  methods: {
    createTwofaInputName() {
      return `graphchain-twofa-${Date.now()}-${Math.random()
        .toString(36)
        .slice(2)}`;
    },
    handleFieldInput(field, value, event) {
      const nextValue =
        field === "twofaCode" ? value.replace(/\D/g, "").slice(0, 6) : value;
      if (event && event.target && event.target.value !== nextValue) {
        event.target.value = nextValue;
      }
      this.$emit("update-form-field", { field, value: nextValue });
      this.$emit("clear-error", field);
    },
    clearField(field) {
      this.$emit("update-form-field", { field, value: "" });
    },
    togglePwd(field) {
      this.$emit("toggle-pwd-vis", field);
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/newLogin/loginStyle.less";
</style>
